import styled from "styled-components";

export const Title = styled("h4")`
  margin: 0px;
  font-size: 16px;
`;

export const Card = styled("div")`
  position: relative;
  overflow: hidden;
  height: 450px;
  width: 100%;
  background-color: rgb(247, 243, 243);
  padding: 15px 15px 40px;
  border-radius: 20px;
`;
